import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Typography } from "../../components/common/Typography/Typography";
import { ContactList } from "../../components/ContactList/ContactList";
import { AsnNetDatabaseContact, AsnNetDatabaseContactList } from "../../ucserver/stubs/ENetUC_Common";

interface ISearchResultContacts {
	searchedContacts: AsnNetDatabaseContactList;
	selectedContactId: string | null;
	isLoading: boolean;
	searchTerm?: string;
	endReached: (index: number) => void;
	onClick: (contact: AsnNetDatabaseContact) => void;
}

export const SearchResultContacts: FC<ISearchResultContacts> = ({
	selectedContactId,
	searchedContacts,
	isLoading,
	searchTerm,
	onClick,
	endReached
}) => {
	const { t } = useTranslation();

	return (
		<>
			<Typography variant="body2" sx={{ pl: 2 }}>
				{t("IDS_CONTACT_SEARCH_RESULTS")}
			</Typography>
			<ContactList
				contacts={searchedContacts}
				endReached={endReached}
				onClick={onClick}
				selectedContactId={selectedContactId}
				isLoading={isLoading}
				searchTerm={searchTerm}
			/>
		</>
	);
};
